import { Pagination, Stack } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import React from "react";
import PropTypes from "prop-types";
import MDButton from "components/MDButton";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import usePermission from "hooks/usePermission";

export default function NodeList({
  handleNodeCreate,
  nodeList,
  handleNodeEdit,
  handleNodeDelete,
  totalData,
  totalPages,
  currentPage,
  setCurrentPage,
}) {
  // Verificar permisos
  const canCreate = usePermission("Crear", "Nodos");
  const canEdit = usePermission("Editar", "Nodos");
  const canDelete = usePermission("Eliminar", "Nodos");
  const canList = usePermission("Listar", "Nodos");

  // Paginación
  const entriesStart = nodeList && nodeList.length > 0 ? (currentPage - 1) * 10 + 1 : 0;
  const entriesEnd = nodeList && nodeList.length > 0 ? entriesStart + nodeList.length - 1 : 0;

  return (
    <>
      <MDBox style={{ display: "flex", justifyContent: "flex-end", marginRight: "2vw" }}>
        {canCreate && (
          <MDButton onClick={handleNodeCreate} variant="gradient" color="info">
            Crear
          </MDButton>
        )}
      </MDBox>
      {canList && (
        <DataTable
          table={{
            columns: [
              { Header: "Nombre", accessor: "name" },
              { Header: "Municipio", accessor: "municipality" },
              {
                Header: "Estado",
                accessor: "active",
                Cell: ({ value }) => (value ? <span>Activo</span> : <span>Inactivo</span>),
              },
              {
                Header: "Acciones",
                accessor: "action",
                width: "12%",
                align: "center",
                disableSortBy: true,
              },
            ],
            rows: nodeList
              ? nodeList.map((node) => ({
                id: node.id,
                name: node.name,
                municipality: node.municipality,
                active: node.active,
                action: (
                  <>
                    {canEdit && (
                      <a
                        data-id={node.id}
                        onClick={(event) => handleNodeEdit(event, node)}
                        style={{ marginLeft: "8px", cursor: "pointer" }}>
                        <EditOutlinedIcon
                          titleAccess="Editar"
                          style={{
                            width: "24px",
                            height: "24px",
                          }}
                        />
                      </a>
                    )}
                    {canDelete && (
                      <a
                        data-id={node.id}
                        onClick={(event) => handleNodeDelete(event, node)}
                        style={{ marginLeft: "8px", cursor: "pointer" }}>
                        <DeleteForeverOutlinedIcon
                          titleAccess="Eliminar"
                          style={{
                            width: "24px",
                            height: "24px",
                          }}
                        />
                      </a>
                    )}
                  </>
                ),
              }))
              : [],
          }}
          canSearch={false}
          isSorted={true}
          entriesPerPage={false}
          showTotalEntries={false}
          pagination={{ variant: "gradient", color: "info" }}
        />
      )}
      {!nodeList || nodeList.length === 0 ? (
        <MDBox style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <MDTypography
            style={{ left: "20px", fontSize: "20px" }}
            variant="button"
            color="secondary"
            fontWeight="regular">
            No hay datos
          </MDTypography>
        </MDBox>
      ) : (
        <>
          <MDBox style={{ marginLeft: "20px" }} mb={{ xs: 3, sm: 0 }}>
            <MDTypography
              style={{ left: "20px" }}
              variant="button"
              color="secondary"
              fontWeight="regular">
              Mostrando {entriesStart} hasta {entriesEnd} de {totalData} resultados en total
            </MDTypography>
          </MDBox>
          <Stack style={{ marginLeft: "20px", marginBottom: "10px" }} spacing={2}>
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={(_, page) => setCurrentPage(page)}
            />
          </Stack>
        </>
      )}
    </>
  );
}

NodeList.propTypes = {
  handleNodeCreate: PropTypes.func,
  nodeList: PropTypes.arrayOf(PropTypes.object),
  handleNodeEdit: PropTypes.func,
  handleNodeDelete: PropTypes.func,
  totalData: PropTypes.number,
  totalPages: PropTypes.number,
  currentPage: PropTypes.number,
  setCurrentPage: PropTypes.func,
};
